/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 利用規約を表します。
 * @export
 * @interface TermAgreementModel
 */
export interface TermAgreementModel {
    /**
     * サイトの名
     * @type {string}
     * @memberof TermAgreementModel
     */
    nameTrimTagline?: string;
    /**
     * 利用規約のリンク先
     * @type {string}
     * @memberof TermAgreementModel
     */
    termUrl?: string;
    /**
     * 利用規約のバージョン
     * @type {string}
     * @memberof TermAgreementModel
     */
    agreementVersion?: string;
}

/**
 * Check if a given object implements the TermAgreementModel interface.
 */
export function instanceOfTermAgreementModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TermAgreementModelFromJSON(json: any): TermAgreementModel {
    return TermAgreementModelFromJSONTyped(json, false);
}

export function TermAgreementModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermAgreementModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nameTrimTagline': !exists(json, 'nameTrimTagline') ? undefined : json['nameTrimTagline'],
        'termUrl': !exists(json, 'termUrl') ? undefined : json['termUrl'],
        'agreementVersion': !exists(json, 'agreementVersion') ? undefined : json['agreementVersion'],
    };
}

export function TermAgreementModelToJSON(value?: TermAgreementModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nameTrimTagline': value.nameTrimTagline,
        'termUrl': value.termUrl,
        'agreementVersion': value.agreementVersion,
    };
}

